import React from "react";
import Button from "../../ui/utils/Button";


const ViewDescription = ({ closeModal, callback, data }) => {
    return (
        <div className="p-4 text-sm">
            <p className="mb-4">
                <span className="font-semibold">{data?.description}</span>
            </p>

            <div className="flex justify-end gap-2">
                <Button variant="secondary" onClick={closeModal}>
                    Close
                </Button>
            </div>
        </div>
    );
};

export default ViewDescription;
